import logo from "./logo.png";
import logoWhite from "./logo-white.png";
import phone1 from "./phone1.png";
import phone2 from "./phone2.png";
import logoIcon from "./logo-icon.png";
import iqlanceLogo from "./iqlance-logoNew.svg";
import tracktime from "./tracktime.png";
import phonecompress from "./phonecompress.png";
import email from "./email.png";
import instaIcon from "./instagram-white-icon.png";
import tiktokIcon from "./tiktok-round-white-icon.png";
import phoneHand from "./phoneHand.png";
import Feeddots from "./Feed-dots.png";
import FeedCalendar from "./Feed-Calendar.png";
import FeedCalendar1 from "./screenshots/Feed-Calendar.png";
import FeedReuestSent from "./screenshots/Feed-ReuestSent.png";
import FeedScrolledup from "./screenshots/Feed-Scrolledup.png";
import LoginPortrait from "./screenshots/Login-portrait.png";
import Profiledots from "./screenshots/Profile-dots.png";
import ProfileFriends from "./screenshots/Profile-Friends.png";
import ProfileMyStudios from "./screenshots/Profile-MyStudios.png";
import appStore from "./appStore.png";
import playStore from "./playStore.png";

export const imgArr = {
  logo,
  logoWhite,
  phone1,
  phone2,
  logoIcon,
  iqlanceLogo,
  tracktime,
  phonecompress,
  email,
  instaIcon,
  tiktokIcon,
  phoneHand,
  Feeddots,
  FeedCalendar,
  FeedCalendar1,
  FeedReuestSent,
  FeedScrolledup,
  LoginPortrait,
  Profiledots,
  ProfileFriends,
  ProfileMyStudios,
  appStore,
  playStore,
};
